export default __webpack_public_path__ + "media/flags/ad-eb626b08.svg";